import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { Link } from 'react-router-dom';
import './CabinetCard.css';

export class CabinetCard extends Component {
  confirmedColor = (status) => {
    if (status === 'Elected' || status === 'Confirmed') {
      return 'confirmedColor';
    }
    if (status === 'Pending') {
      return 'defaultColor';
    }
  };

  render() {
    return (
      <Card className="box">
        <Card.Img variant="top" src={this.props.pick.imgPath} />

        <Card.Body>
          <Card.Title id="title">{this.props.pick.title}</Card.Title>
          <h6 className="memberName">{this.props.pick.name}</h6>
          <p className={this.confirmedColor(this.props.pick.isConfirmed)}>
            {this.props.pick.isConfirmed}
          </p>

          <Link to={`/cabinet/${this.props.pick.title}`}>
            <Button
              className="moreInfoButton"
              id="info"
              variant="outline-secondary"
            >
              Read More
            </Button>
          </Link>
        </Card.Body>
      </Card>
    );
  }
}

export default CabinetCard;
